import React, { useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { C, IMG } from '../theme';

const LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/about', label: 'About Us' },
  { to: '/services', label: 'Our Services' },
  { to: '/contact', label: 'Contact' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const navBtn = {
    background: 'none', border: 'none', fontFamily: 'inherit', fontSize: 15.5,
    fontWeight: 700, color: '#2C3A34', padding: '10px 16px', borderRadius: 10,
    cursor: 'pointer', position: 'relative', textDecoration: 'none',
  };
  const underline = {
    position: 'absolute', left: 16, right: 16, bottom: 4, height: 2.5,
    borderRadius: 2, background: C.orange,
  };

  return (
    <header style={{
      position: 'sticky', top: 0, zIndex: 50,
      background: 'rgba(251,247,240,.88)', backdropFilter: 'blur(12px)',
      borderBottom: `1px solid ${C.line}`,
    }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto', padding: '14px 24px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24,
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <img src={`${IMG}/logo.png`} alt="CarelyNest" style={{ height: 44, width: 'auto' }} />
        </Link>

        <nav data-cn-desktop-nav style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className="cn-nav-btn" style={navBtn}>
              {({ isActive }) => (
                <>
                  {l.label}
                  {isActive && <span style={underline} />}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div data-cn-desktop-cta style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          <button
            className="cn-primary-btn"
            onClick={() => navigate('/contact')}
            style={{
              background: C.orange, color: '#fff', border: 'none', fontFamily: 'inherit',
              fontSize: 15, fontWeight: 800, padding: '12px 22px', borderRadius: 999,
              cursor: 'pointer', boxShadow: '0 10px 22px -10px rgba(224,124,69,.7)',
            }}
          >
            Find a caregiver
          </button>
        </div>

        <button
          data-cn-burger
          aria-label="Toggle menu"
          onClick={() => setOpen((o) => !o)}
          style={{ display: 'none', background: 'none', border: '1px solid #D9D2C4', borderRadius: 10, padding: '9px 11px', cursor: 'pointer' }}
        >
          {[0, 1, 2].map((i) => (
            <span key={i} style={{ display: 'block', width: 20, height: 2, background: C.teal, borderRadius: 2, margin: '4px 0' }} />
          ))}
        </button>
      </div>

      {open && (
        <div style={{ borderTop: `1px solid ${C.line}`, background: C.cream, padding: '8px 16px 16px', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              onClick={() => setOpen(false)}
              style={{ textAlign: 'left', fontSize: 17, fontWeight: 700, color: '#2C3A34', padding: '14px 12px', borderRadius: 10 }}
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => { setOpen(false); navigate('/contact'); }}
            style={{ marginTop: 8, background: C.orange, color: '#fff', border: 'none', fontFamily: 'inherit', fontSize: 16, fontWeight: 800, padding: '14px 22px', borderRadius: 999, cursor: 'pointer' }}
          >
            Find a caregiver
          </button>
        </div>
      )}
    </header>
  );
}
